/**
 * Banner.js — Home page hero banner.
 *
 * Renders the full-width hero banner at the top of the home page.
 * Banner content (title, subtitle, image, button) is fetched by HomePage
 * from the admin panel API and passed in as props.
 *
 * Props:
 *  - BannerImage {string}      Background image URL.
 *  - BannerTitle {string}      Main heading text.
 *  - BannerSubTitle {string}   Sub-heading text.
 *  - BannerButtonText {string} CTA button label.
 *  - BannerButtonUrl {string}  CTA button href destination.
 *  - GAurl {string}            Google Ads click-ID query string (appended to button URL).
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';


// ─── Main component ───────────────────────────────────────────────────────────

/**
 * HeroBanner — home page hero banner.
 * See file-level JSDoc for full props description.
 */
export const HeroBanner = (props) => {

  return (
    <div className="hero_banner_wrapper" style={props.BannerImage ? { backgroundImage: "url(" + props.BannerImage + ")" } : undefined}>
      <div className='banner_overlay'></div>

      <Container>
        <Row>
          <Col lg={5} md={8} xs={12}>
            <div className='hero_banner_content'>

              {props.BannerTitle !== null && props.BannerTitle !== undefined ? <h1>{props.BannerTitle}</h1> : null}
              {props.BannerSubTitle !== null && props.BannerSubTitle !== undefined ? <h2>{props.BannerSubTitle}</h2> : null}
              {props.BannerButtonUrl !== null && props.BannerButtonText !== undefined && props.BannerButtonText !== null ? (
                <a href={props.BannerButtonUrl + props.GAurl} className='btn btn-hero'>
                  {props.BannerButtonText} <span aria-hidden="true">→</span>
                </a>
              ) : null}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroBanner;
